import React, { useEffect, useState } from 'react';
import close_btn from '../../assets/close.svg';
import '../../css/shillaDetail.css';
import checkImg from '../../assets/check.png';
import shareImg from '../../assets/share.png';
import aboutIcon from '../../assets/aboutIcon.png';
import toggleIcon from '../../assets/toggleIcon.png';
import nftAboutIcon from '../../assets/nftAboutMenu.png';
import { useRecoilValue } from 'recoil';
import { translatedText } from '../../recoil-states/language-state';
import ProgressiveImage from 'react-progressive-graceful-image';
import { AnimatePresence, motion } from 'framer-motion';
import Lottie from 'react-lottie-player';

const ShillaGalleryDetail = ({
    itemData,
    setOpenModal,
    setOpenShiModal,
    view = true,
}) => {
    const [openAbout, setOpenAbout] = useState(true);
    const [openDes, setOpenDes] = useState(true);
    const textData = useRecoilValue(translatedText);

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    const tier1Content = [
        '신라면세점 국내 전지점 면세정상가 대비 20% 추가할인',
        '신라호텔 시내 면세점 서울점 20% + 10%추가 (KCT리워드)',
        'S.Point 20,000점 지원',
        'VIP라운지 무료이용권',
        '신라 면세점 서울점 무료발렛 서비스',
        '신라 온라인면세점 면세 정상가 대비 15% 할인',
    ];

    const tier2Content = [
        '신라온라인면세점 온라인 몰 10만 포인트 적립',
        '브랜드 시크릿행사 VIP초대권',
        '신라호텔 시내면세점 1:1 컨시어지 서비스',
        '티어1 전용 안내서비스',
    ];

    const onCloseModal = e => {
        if (e.target.id === 'shilla_gallery_modal') {
            itemData != undefined ? setOpenShiModal(false) : setOpenModal(null);
        }
    };

    return (
        <AnimatePresence>
            <div
                className='shilla_detail'
                id='shilla_gallery_modal'
                onClick={onCloseModal}
            >
                <motion.div
                    className='shilla_detail_container'
                    initial={{
                        opacity: 0,
                        scale: 0.75,
                    }}
                    animate={{
                        opacity: 1,
                        scale: 1,
                        transition: {
                            ease: 'easeOut',
                            duration: 0.15,
                        },
                    }}
                    exit={{
                        opacity: 0,
                        scale: 0.75,
                        transition: {
                            ease: 'easeIn',
                            duration: 0.15,
                        },
                    }}
                >
                    <div className='nft_box_container'>
                        <div
                            className='close_btn_svg'
                            onClick={() => {
                                itemData != undefined
                                    ? setOpenShiModal(false)
                                    : setOpenModal(null);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <img src={close_btn} />
                        </div>
                        <div className='shilla_detail_image'>
                            <ProgressiveImage
                                src={
                                    itemData != undefined
                                        ? `${process.env.REACT_APP_BACKEND_API}/assets/${itemData.image}`
                                        : require('../../assets/shilla-pack.png')
                                }
                            >
                                {(src, loading) => {
                                    return !loading ? (
                                        <img
                                            src={src}
                                            style={{
                                                width: '100%',
                                                borderRadius: '10px',
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                borderRadius: '10px 10px 0 0',
                                                margin: '50px 0',
                                            }}
                                        >
                                            {/* <h1>로딩</h1> */}
                                            <Lottie
                                                animationData={require('../../assets/lod.json')}
                                                play
                                                loop
                                                style={{
                                                    borderRadius: '10px 10px 0 0',
                                                }}
                                            />
                                        </div>
                                    );
                                }}
                            </ProgressiveImage>
                        </div>
                        <div className='konnect_text'>
                            <h3>
                                Konnect World
                                <img src={checkImg} />
                            </h3>
                            <p>
                                Owned by <span>Konnect</span>
                                <img src={shareImg} />
                            </p>
                        </div>
                        <div className='nft_detail_text_box'>
                            <div className='text_box_left'>
                                <h1>Konnect</h1>
                                <h1>SHILLA VIP Membership</h1>
                            </div>
                            <div className='text_box_right'>
                                <p>#001</p>
                            </div>
                        </div>
                        <div className='nft_about_box'>
                            <div
                                className='nft_about_top'
                                style={{ borderRadius: !openAbout ? '10px' : null }}
                                onClick={() => setOpenAbout(!openAbout)}
                            >
                                <div className='nft_about_box_left'>
                                    <img src={aboutIcon} />
                                    <h1>About Shilla VIP Membership</h1>
                                </div>
                                <div className='nft_about_box_right'>
                                    <img
                                        src={toggleIcon}
                                        style={{
                                            transform: openAbout
                                                ? 'rotate(0deg)'
                                                : 'rotate(180deg)',
                                        }}
                                    />
                                </div>
                            </div>
                            <div
                                className='nft_about_content'
                                aria-expanded={!openAbout}
                            >
                                <p>{textData.pakageCard.Shilla}</p>
                            </div>
                        </div>
                        <div className='nft_about_box'>
                            <div
                                className='nft_about_top'
                                style={{ borderRadius: !openDes ? '10px' : null }}
                                onClick={() => setOpenDes(!openDes)}
                            >
                                <div className='nft_about_box_left'>
                                    <img src={nftAboutIcon} />
                                    <h1>Description</h1>
                                </div>
                                <div className='nft_about_box_right'>
                                    <img
                                        src={toggleIcon}
                                        style={{
                                            transform: openDes
                                                ? 'rotate(0deg)'
                                                : 'rotate(180deg)',
                                        }}
                                    />
                                </div>
                            </div>
                            {
                                <div
                                    className='nft_about_content_bottom'
                                    aria-expanded={!openDes}
                                >
                                    <p>KONNECT SHILLA VIP MEMBERSHIP</p>
                                    <h1>Benefit Information</h1>
                                    <div className='shilla_tier'>
                                        <div className='tier_one_top'>
                                            <h1>Tier1</h1>
                                        </div>
                                        <ul>
                                            {textData.tier.shilla.tier1.map(it => {
                                                return <li key={it}>◆ {it}</li>;
                                            })}
                                        </ul>
                                        <div className='shlla_tier_two'>
                                            <div className='tier_two_top'>
                                                <h1>Tier2</h1>
                                            </div>
                                            <ul>
                                                {textData.tier.shilla.tier2.map(
                                                    it => {
                                                        return (
                                                            <li
                                                                style={{
                                                                    color: '#BBBBBB',
                                                                }}
                                                                key={it}
                                                            >
                                                                ◆ {it}
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {view ? (
                            <div className='detail_modal_btn_container'>
                                <div className='detail_modal_btn_top'>
                                    <button className='clasic_button'>
                                        멤버쉽 정보 보기
                                    </button>
                                    <button className='clasic_button'>
                                        My Wallet으로 이동
                                    </button>
                                </div>
                                <div className='detail_modal_btn_bottom'>
                                    <button className='activity_button_full'>
                                        예약하기
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default ShillaGalleryDetail;
